import script from "./ProcesoAutoevaluacionAdminView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProcesoAutoevaluacionAdminView.vue?vue&type=script&lang=ts&setup=true"

import "./ProcesoAutoevaluacionAdminView.vue?vue&type=style&index=0&id=47f48285&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f48285"]])

export default __exports__